var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./List.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2de24fd3\"}!../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/attributesSet/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2de24fd3", Component.options)
  } else {
    hotAPI.reload("data-v-2de24fd3", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/views/registration/attributesSet/List.vue
// module id = 1332
// module chunks = 0